(() => {
  if (customElements.get('zb-product-size-comparison')) return;
  class ProductSizeComparison extends HTMLElement {
    connectedCallback() {
      this.root = document.querySelector('[data-zb-product-main]');
      if (!this.root || this.ready) return;
      this.ready = true;
      this.sizeIndex = Number(this.dataset.sizeIndex);
      this.designIndex = Number(this.dataset.designIndex);
      this.cards = Array.from(this.querySelectorAll('[data-size-card]'));
      this.templates = Array.from(this.querySelectorAll('[data-size-photo-template]'));
      this.rail = this.querySelector('[data-size-rail]');
      this.lastDesign = this.dataset.initialDesign;
      this.variants = [];
      try {
        this.variants = JSON.parse(this.root.querySelector('[data-zb-variants-json]')?.textContent || '[]');
      } catch (error) {
        console.warn('ZB size comparison: variant data could not be read.', error);
      }
      this.onChange = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateNavigation();
        });
      };
      this.onClick = event => {
        if (event.target.closest('[data-size-chart-jump]')) {
          const chart = document.getElementById('zb-product-size-chart');
          if (!chart) return;
          event.preventDefault();
          chart.open = true;
          chart.querySelector('summary')?.focus({ preventScroll: true });
          chart.scrollIntoView({ behavior: this.scrollBehavior(), block: 'start' });
        }
        const previous = event.target.closest('[data-size-previous]');
        const next = event.target.closest('[data-size-next]');
        if (previous || next) this.rail.scrollBy({ left: this.rail.clientWidth * (previous ? -0.8 : 0.8), behavior: this.scrollBehavior() });
      };
      this.root.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(this.onScroll);
        this.resizeObserver.observe(this.rail);
      }
      this.sync();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.rail?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.scrollFrame);
      this.ready = false;
    }
    scrollBehavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    sync() {
      const options = Array.from(this.root.querySelectorAll('[data-zb-option-group]')).map(group => group.querySelector('[data-zb-option-value]:checked')?.value || '');
      const design = this.designIndex >= 0 ? options[this.designIndex] || '' : '';
      const size = this.sizeIndex >= 0 ? options[this.sizeIndex] || '' : '';
      const template = this.templates.find(item => item.dataset.design === design);
      const photo = template?.content.querySelector('.zbpsc__photo');
      this.querySelector('[data-size-design]').textContent = design;
      this.querySelector('[data-size-reference]').hidden = !photo || photo.dataset.reference !== 'true';
      this.querySelector('[data-size-no-image]').hidden = Boolean(photo);
      this.querySelector('[data-size-visuals]').hidden = !photo;
      const changed = design !== this.lastDesign;
      for (const card of this.cards) {
        if (changed) {
          const image = card.querySelector('[data-size-image]');
          image.replaceChildren();
          if (photo) image.append(photo.cloneNode(true));
        }
        const matching = this.variants.filter(variant => variant.options.every((value, index) => index === this.sizeIndex ? value === card.dataset.sizeValue : !options[index] || options[index] === value));
        if (this.variants.length) card.hidden = matching.length === 0;
        const selected = Boolean(size) && size === card.dataset.sizeValue;
        card.classList.toggle('is-selected', selected);
        card.querySelector('[data-size-selected]').hidden = !selected;
        card.querySelector('[data-size-sold-out]').hidden = !this.variants.length || matching.some(variant => variant.available);
      }
      if (changed) this.rail.scrollLeft = 0;
      this.lastDesign = design;
      this.updateNavigation();
    }
    updateNavigation() {
      const maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      this.querySelector('[data-size-navigation]').hidden = maximum < 2;
      this.querySelector('[data-size-previous]').disabled = this.rail.scrollLeft < 2;
      this.querySelector('[data-size-next]').disabled = this.rail.scrollLeft >= maximum - 2;
    }
  }
  customElements.define('zb-product-size-comparison', ProductSizeComparison);
})();
